import React, { memo, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { formatCurrentDate } from '../../common/utilities/dateTimeUtils';

const dateFormatStr = 'EEEE, LLL d';
const dateFormat = formatCurrentDate(dateFormatStr) ?? '--';
const dateTimeInterval = 24 * 60 * 60 * 1000; // if widget is left open, update every time 24hrs
export const DateText = memo(() => {
    const [currDateTime, setCurrDateTime] = useState<string>(dateFormat);
    const dateTimeRef = useRef<ReturnType<typeof setInterval>>();

    useEffect(() => {
        dateTimeRef.current = setInterval(
            () => {
                setCurrDateTime(dateFormat);
            }, dateTimeInterval);

        return () => {
            if (dateTimeRef.current) {
                clearInterval(dateTimeRef.current);
            }
        };
    }, []);
    
    return (
        <DateTextContainer>{currDateTime}</DateTextContainer>
    );
});

DateText.displayName = 'DateText';

const DateTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 4vw;
    height: 13%;
`;